var NavaidListingComponent = /** @class */ (function () {
    function NavaidListingComponent() {
    }
    Object.defineProperty(NavaidListingComponent.prototype, "sortedNavaids", {
        get: function () {
            return (this.navaids || []).sort(function (n1, n2) { return n1.distance - n2.distance; });
        },
        enumerable: true,
        configurable: true
    });
    NavaidListingComponent.prototype.onNavaidDeleted = function (navaidId) {
        var index = this.navaids.findIndex(function (n) { return n.navaidId === navaidId; });
        if (index > -1) {
            this.navaids.splice(index, 1);
        }
    };
    return NavaidListingComponent;
}());
export { NavaidListingComponent };
